document.addEventListener('DOMContentLoaded', function() {
  const menuDrawer = document.getElementById('menu-drawer');
  if (!menuDrawer) return;

  const faqItems = menuDrawer.querySelectorAll('details');
  
  faqItems.forEach(function(item) {
    const summary = item.querySelector('summary');
    const content = item.querySelector('.menu-drawer__submenu');
    
    if (!summary || !content) return;

    summary.addEventListener('click', function(e) {
      if (e.target.closest('a')) {
        return;
      }
      e.preventDefault();
      
      const isOpen = item.hasAttribute('open');
      
      if (isOpen) {
        // Closing animation
        const currentHeight = content.scrollHeight + 'px';
        content.style.height = currentHeight;
        
        requestAnimationFrame(function() {
          content.style.transition = 'height 0.3s ease';
          content.style.height = '0px';
        });
        
        content.addEventListener('transitionend', () => {
          item.removeAttribute('open');
          content.style.removeProperty('height');
          content.style.removeProperty('transition');
        }, { once: true });
        
      } else {
        // Opening animation
        content.style.height = '0px';
        item.setAttribute('open', '');
        const targetHeight = content.scrollHeight + 'px';
        
        requestAnimationFrame(function() {
          content.style.transition = 'height 0.3s ease';
          content.style.height = targetHeight;
        });
        
        content.addEventListener('transitionend', () => {
          content.style.removeProperty('height');
          content.style.removeProperty('transition');
        }, { once: true });
      }
    });
  });
}); 